/**
 * RESPONSIBILITY: one thing a first-time visitor is glad to know before they arrive.
 *
 * The words are content; the little drawing beside them is not. An editor decides a tag
 * says "Free parking"; which mark is drawn is chosen from a fixed set, because asking
 * somebody to paste SVG into a text box is not an edit menu.
 */
import { Row, Text, Choice } from '@framework/core/decorators';

export const WELCOME_MARK = {
  None: 'none',
  Refreshments: 'refreshments',
  Children: 'children',
  Parking: 'parking',
} as const;

export const WELCOME_MARKS = Object.values(WELCOME_MARK);

@Row()
export class WelcomeTag {
  @Text({ label: 'Words', maxLength: 120, description: 'e.g. Free parking.' })
  label!: string;

  @Choice({
    label: 'Mark', options: WELCOME_MARKS, default: WELCOME_MARK.None,
    description: 'The drawing beside the words. "none" leaves the tag plain.',
  })
  icon!: string;
}
